import { ElementContent } from './ElementData';

class TrainingLogRegionContent extends ElementContent {

    constructor({
        positionX = 0,
        positionY = 0,
        width = 900,
        height = 400,
    }: Partial<TrainingLogRegionContent> = {}) {
        super(positionX, positionY, width, height);
        this.allowedFields = ['positionX', 'positionY', 'width', 'height', 'zIndex'];
    }
};

export default TrainingLogRegionContent;